function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { isPlainObject, dateTimestampInSeconds, SyncPromise, logger, isThenable, arrayify, getGlobalSingleton } from '@sentry/utils';
import { updateSession } from './session.js';
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */

var DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */

var Scope = /*#__PURE__*/function () {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /** Transaction Name */

  /** Span */

  /** Session */

  /** Request Mode Session Status */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  function Scope() {
    _classCallCheck(this, Scope);

    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
  }
  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */


  _createClass(Scope, [{
    key: "addScopeListener",
    value:
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    function addScopeListener(callback) {
      this._scopeListeners.push(callback);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "addEventProcessor",
    value: function addEventProcessor(callback) {
      this._eventProcessors.push(callback);

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setUser",
    value: function setUser(user) {
      this._user = user || {};

      if (this._session) {
        updateSession(this._session, {
          user: user
        });
      }

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getUser",
    value: function getUser() {
      return this._user;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getRequestSession",
    value: function getRequestSession() {
      return this._requestSession;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setRequestSession",
    value: function setRequestSession(requestSession) {
      this._requestSession = requestSession;
      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setTags",
    value: function setTags(tags) {
      this._tags = _objectSpread(_objectSpread({}, this._tags), tags);

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setTag",
    value: function setTag(key, value) {
      this._tags = _objectSpread(_objectSpread({}, this._tags), {}, _defineProperty({}, key, value));

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setExtras",
    value: function setExtras(extras) {
      this._extra = _objectSpread(_objectSpread({}, this._extra), extras);

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setExtra",
    value: function setExtra(key, extra) {
      this._extra = _objectSpread(_objectSpread({}, this._extra), {}, _defineProperty({}, key, extra));

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setFingerprint",
    value: function setFingerprint(fingerprint) {
      this._fingerprint = fingerprint;

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setLevel",
    value: function setLevel( // eslint-disable-next-line deprecation/deprecation
    level) {
      this._level = level;

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setTransactionName",
    value: function setTransactionName(name) {
      this._transactionName = name;

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setContext",
    value: function setContext(key, context) {
      if (context === null) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
      } else {
        this._contexts[key] = context;
      }

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setSpan",
    value: function setSpan(span) {
      this._span = span;

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getSpan",
    value: function getSpan() {
      return this._span;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getTransaction",
    value: function getTransaction() {
      // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
      // have a pointer to the currently-active transaction.
      var span = this.getSpan();
      return span && span.transaction;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setSession",
    value: function setSession(session) {
      if (!session) {
        delete this._session;
      } else {
        this._session = session;
      }

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getSession",
    value: function getSession() {
      return this._session;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "update",
    value: function update(captureContext) {
      if (!captureContext) {
        return this;
      }

      if (typeof captureContext === 'function') {
        var updatedScope = captureContext(this);
        return updatedScope instanceof Scope ? updatedScope : this;
      }

      if (captureContext instanceof Scope) {
        this._tags = _objectSpread(_objectSpread({}, this._tags), captureContext._tags);
        this._extra = _objectSpread(_objectSpread({}, this._extra), captureContext._extra);
        this._contexts = _objectSpread(_objectSpread({}, this._contexts), captureContext._contexts);

        if (captureContext._user && Object.keys(captureContext._user).length) {
          this._user = captureContext._user;
        }

        if (captureContext._level) {
          this._level = captureContext._level;
        }

        if (captureContext._fingerprint) {
          this._fingerprint = captureContext._fingerprint;
        }

        if (captureContext._requestSession) {
          this._requestSession = captureContext._requestSession;
        }
      } else if (isPlainObject(captureContext)) {
        // eslint-disable-next-line no-param-reassign
        captureContext = captureContext;
        this._tags = _objectSpread(_objectSpread({}, this._tags), captureContext.tags);
        this._extra = _objectSpread(_objectSpread({}, this._extra), captureContext.extra);
        this._contexts = _objectSpread(_objectSpread({}, this._contexts), captureContext.contexts);

        if (captureContext.user) {
          this._user = captureContext.user;
        }

        if (captureContext.level) {
          this._level = captureContext.level;
        }

        if (captureContext.fingerprint) {
          this._fingerprint = captureContext.fingerprint;
        }

        if (captureContext.requestSession) {
          this._requestSession = captureContext.requestSession;
        }
      }

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "clear",
    value: function clear() {
      this._breadcrumbs = [];
      this._tags = {};
      this._extra = {};
      this._user = {};
      this._contexts = {};
      this._level = undefined;
      this._transactionName = undefined;
      this._fingerprint = undefined;
      this._requestSession = undefined;
      this._span = undefined;
      this._session = undefined;

      this._notifyScopeListeners();

      this._attachments = [];
      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "addBreadcrumb",
    value: function addBreadcrumb(breadcrumb, maxBreadcrumbs) {
      var maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS; // No data has been changed, so don't notify scope listeners

      if (maxCrumbs <= 0) {
        return this;
      }

      var mergedBreadcrumb = _objectSpread({
        timestamp: dateTimestampInSeconds()
      }, breadcrumb);

      this._breadcrumbs = [].concat(_toConsumableArray(this._breadcrumbs), [mergedBreadcrumb]).slice(-maxCrumbs);

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getLastBreadcrumb",
    value: function getLastBreadcrumb() {
      return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "clearBreadcrumbs",
    value: function clearBreadcrumbs() {
      this._breadcrumbs = [];

      this._notifyScopeListeners();

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "addAttachment",
    value: function addAttachment(attachment) {
      this._attachments.push(attachment);

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getAttachments",
    value: function getAttachments() {
      return this._attachments;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "clearAttachments",
    value: function clearAttachments() {
      this._attachments = [];
      return this;
    }
    /**
     * Applies data from the scope to the event and runs all event processors on it.
     *
     * @param event Event
     * @param hint Object containing additional information about the original exception, for use by the event processors.
     * @hidden
     */

  }, {
    key: "applyToEvent",
    value: function applyToEvent(event) {
      var hint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this._extra && Object.keys(this._extra).length) {
        event.extra = _objectSpread(_objectSpread({}, this._extra), event.extra);
      }

      if (this._tags && Object.keys(this._tags).length) {
        event.tags = _objectSpread(_objectSpread({}, this._tags), event.tags);
      }

      if (this._user && Object.keys(this._user).length) {
        event.user = _objectSpread(_objectSpread({}, this._user), event.user);
      }

      if (this._contexts && Object.keys(this._contexts).length) {
        event.contexts = _objectSpread(_objectSpread({}, this._contexts), event.contexts);
      }

      if (this._level) {
        event.level = this._level;
      }

      if (this._transactionName) {
        event.transaction = this._transactionName;
      } // We want to set the trace context for normal events only if there isn't already
      // a trace context on the event. There is a product feature in place where we link
      // errors with transaction and it relies on that.


      if (this._span) {
        event.contexts = _objectSpread({
          trace: this._span.getTraceContext()
        }, event.contexts);
        var transactionName = this._span.transaction && this._span.transaction.name;

        if (transactionName) {
          event.tags = _objectSpread({
            transaction: transactionName
          }, event.tags);
        }
      }

      this._applyFingerprint(event);

      event.breadcrumbs = [].concat(_toConsumableArray(event.breadcrumbs || []), _toConsumableArray(this._breadcrumbs));
      event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
      event.sdkProcessingMetadata = _objectSpread(_objectSpread({}, event.sdkProcessingMetadata), this._sdkProcessingMetadata);
      return this._notifyEventProcessors([].concat(_toConsumableArray(getGlobalEventProcessors()), _toConsumableArray(this._eventProcessors)), event, hint);
    }
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */

  }, {
    key: "setSDKProcessingMetadata",
    value: function setSDKProcessingMetadata(newData) {
      this._sdkProcessingMetadata = _objectSpread(_objectSpread({}, this._sdkProcessingMetadata), newData);
      return this;
    }
    /**
     * This will be called after {@link applyToEvent} is finished.
     */

  }, {
    key: "_notifyEventProcessors",
    value: function _notifyEventProcessors(processors, event, hint) {
      var _this = this;

      var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      return new SyncPromise(function (resolve, reject) {
        var processor = processors[index];

        if (event === null || typeof processor !== 'function') {
          resolve(event);
        } else {
          var result = processor(_objectSpread({}, event), hint);
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && processor.id && result === null && logger.log("Event processor \"".concat(processor.id, "\" dropped event"));

          if (isThenable(result)) {
            void result.then(function (final) {
              return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
            }).then(null, reject);
          } else {
            void _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
          }
        }
      });
    }
    /**
     * This will be called on every set call.
     */

  }, {
    key: "_notifyScopeListeners",
    value: function _notifyScopeListeners() {
      var _this2 = this;

      // We need this check for this._notifyingListeners to be able to work on scope during updates
      // If this check is not here we'll produce endless recursion when something is done with the scope
      // during the callback.
      if (!this._notifyingListeners) {
        this._notifyingListeners = true;

        this._scopeListeners.forEach(function (callback) {
          callback(_this2);
        });

        this._notifyingListeners = false;
      }
    }
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */

  }, {
    key: "_applyFingerprint",
    value: function _applyFingerprint(event) {
      // Make sure it's an array first and we actually have something in place
      event.fingerprint = event.fingerprint ? arrayify(event.fingerprint) : []; // If we have something on the scope, then merge it with event

      if (this._fingerprint) {
        event.fingerprint = event.fingerprint.concat(this._fingerprint);
      } // If we have no data at all, remove empty array default


      if (event.fingerprint && !event.fingerprint.length) {
        delete event.fingerprint;
      }
    }
  }], [{
    key: "clone",
    value: function clone(scope) {
      var newScope = new Scope();

      if (scope) {
        newScope._breadcrumbs = _toConsumableArray(scope._breadcrumbs);
        newScope._tags = _objectSpread({}, scope._tags);
        newScope._extra = _objectSpread({}, scope._extra);
        newScope._contexts = _objectSpread({}, scope._contexts);
        newScope._user = scope._user;
        newScope._level = scope._level;
        newScope._span = scope._span;
        newScope._session = scope._session;
        newScope._transactionName = scope._transactionName;
        newScope._fingerprint = scope._fingerprint;
        newScope._eventProcessors = _toConsumableArray(scope._eventProcessors);
        newScope._requestSession = scope._requestSession;
        newScope._attachments = _toConsumableArray(scope._attachments);
        newScope._sdkProcessingMetadata = _objectSpread({}, scope._sdkProcessingMetadata);
      }

      return newScope;
    }
  }]);

  return Scope;
}();
/**
 * Returns the global event processors.
 */


function getGlobalEventProcessors() {
  return getGlobalSingleton('globalEventProcessors', function () {
    return [];
  });
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */


function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}

export { Scope, addGlobalEventProcessor };